module.exports = __webpack_public_path__ + "static/img/Daniel Wiyogo-close.8146233.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/profile/closeup/Daniel Wiyogo-close.jpg
// module id = U8FY
// module chunks = 1